import { render, staticRenderFns } from "./Piece.vue?vue&type=template&id=1b35adf3&scoped=true&"
import script from "./Piece.vue?vue&type=script&lang=js&"
export * from "./Piece.vue?vue&type=script&lang=js&"
import style0 from "./Piece.vue?vue&type=style&index=0&id=1b35adf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b35adf3",
  null
  
)

export default component.exports